<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" :canAdd="false"
        :isSearch="true" :canSearch="false">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados da Entrada de Ração</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md6 lg6>
                    <SelectDate :rules="[campoObrigatorio, validarData, validarDataFutura]" label="Data" v-model="dataEntrada"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorZero]" v-model.number="registro.qtRacao" type="number" label="Quantidade de Ração(kg)" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados da Ração</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdRacao" :items="racoes" clearable
                        color="primary" item-text="displayName" item-value="idRacao" label="Selecione a ração por nome ou código na empresa" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdFabricaRacao" :items="fabricasRacao" clearable
                        color="primary" item-text="displayName" item-value="idFabricaRacao" label="Selecione a fábrica de ração por registro no SIF ou nome"
                        outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados da Nota Fiscal</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field :rules="[campoObrigatorio]" v-mask="maskNotaFiscal" v-model.number="registro.nrNotaFiscal" type="tel" label="Número" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-text-field :rules="[tamanhoMaximoVinte]" v-model.trim="registro.dsPartida" v-mask="maskNotaFiscal" label="Partida/Lote" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, validarData, validarDataFutura, campoMaiorZero, tamanhoMaximoVinte } from '@/filters/rules'
import { MensagemSuccessSave } from '@/resourceMessageFile.js'
import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'
import { mask } from 'vue-the-mask'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import SelectDate from '@/components/general/SelectDate.vue'

export default {
    name: 'EntradaRacao',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        SelectDate,
    },
    directives: {
        mask,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            isLoading: false,
            cdLoteProducao: 0,
            dataEntrada: '',
            maskNotaFiscal: '#########',
            maskNumber: '########',
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Entrada de Ração: ' + this.registro.idEntradaRacao

                return 'Inserindo nova Entrada de Ração'
            }
        },
        racoes () {
            return this.$store.getters.getActiveRations
        },
        fabricasRacao () {
            return this.$store.state.fabricasRacao
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        validarData, 
        validarDataFutura, 
        campoMaiorZero,
        dateLocalToIso,
        dateIsoToLocal,
        tamanhoMaximoVinte,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadRacoes')
            this.$store.dispatch('actLoadFabricasRacao')
            this.cdLoteProducao = parseInt(route.params.idLote)
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('entrada-racao/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.registro = Object.assign({}, rec)
                this.dataEntrada = this.dateIsoToLocal(rec.dtEntrada)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.dtEntrada = this.dateLocalToIso(this.dataEntrada)
            var floatQtRacao = this.registro.qtRacao.toString().replace(',', '.')
            this.registro.qtRacao = parseFloat(parseFloat(floatQtRacao).toFixed(3))
            this.$axios.post('entrada-racao/', this.registro)
            .then((response) => {
                this.$router.go(-1)
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.dtEntrada = this.dateLocalToIso(this.dataEntrada)
            var floatQtRacao = this.registro.qtRacao.toString().replace(',', '.')
            this.registro.qtRacao = parseFloat(parseFloat(floatQtRacao).toFixed(3))
            this.$axios.put('entrada-racao/' + this.registro.idEntradaRacao, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('entrada-racao/' + this.registro.idEntradaRacao)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idEntradaRacao: '',
                dtEntrada: null,
                nrNotaFiscal: '',
                nrSerie: '',
                dsPartida: '',
                qtRacao: 0,
                cdRacao: 0,
                cdFabricaRacao: 0,
                cdLoteProducao: this.cdLoteProducao,
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
